import {gql} from "apollo-angular";
import {baseResponse} from "src/app/store/base.graphql";

const roleFields = `
    id
    roleUniqueId
    roleName
    roleIsAdmin
    roleIsSystemDefault
    roleDescription
    rolePermissions {
        id
        permissionUniqueId
        permissionName
        permissionCode
    }
`;

export const CREATE_USER_ROLE = gql`
    mutation CreateUserRole($input: RoleInputObjects!) {
        createUserRole(input: $input) {
            data{
                ${roleFields}
            }
            response{
                ${baseResponse}
            }
        }
    }
`;

export const UPDATE_USER_ROLE = gql`
    mutation UpdateUserRole($input: RoleInputObjects!) {
        updateUserRole(input: $input) {
            data{
                ${roleFields}
            }
            response{
                ${baseResponse}
            }
        }
    }
`;

export const GET_USER_ROLES = gql`
    query GetRoles($filtering: RoleFilteringInputObjects!) {
        getRoles(filtering: $filtering) {
            data{
                ${roleFields}
            }
            response{
                ${baseResponse}
            }
        }
    }
`;

export const DELETE_USER_ROLE = gql`
    mutation DeleteUserRole($roleUniqueId: String!) {
        deleteUserRole(roleUniqueId: $roleUniqueId) {
            response{
                ${baseResponse}
            }
        }
    }
`;
